module.exports = __webpack_public_path__ + "static/media/3.08b40100.jpg";